export default __webpack_public_path__ + "4abc4ceb05a2611064d51bb1b778ec2a.png";